import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { ConsoleLogger, HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface PurchaseKsefNumberAlreadyInUseQueryParams {
    ksefDocumentId: string;
}

export interface PurchaseKsefNumberAlreadyInUseQueryResult {
    documentId: number | null;
}

export class PurchaseKsefNumberAlreadyInUseQuery extends Query<PurchaseKsefNumberAlreadyInUseQueryResult> {
    public constructor(public readonly params: PurchaseKsefNumberAlreadyInUseQueryParams) {
        super();
    }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(PurchaseKsefNumberAlreadyInUseQuery)
export class PurchaseKsefNumberAlreadyInUseQueryHandler implements QueryHandler<PurchaseKsefNumberAlreadyInUseQuery> {
    #Url = TaggedUrl.join('purchase/:ksefDocumentId/checkKsefReferenceNumber', [Tags.Api]);
    #http = inject(Http) as HttpService;
    #logger = new ConsoleLogger(this.constructor.name);

    public async handleAsync({ params }: PurchaseKsefNumberAlreadyInUseQuery): Promise<PurchaseKsefNumberAlreadyInUseQueryResult> {
        try {
            const url = fillPlaceholders(this.#Url, { ksefDocumentId: params.ksefDocumentId });
            const { data } = await this.#http.get(url);
            return data;
        } catch (err) {
            this.#logger.error(err);
            return {
                documentId: null
            }
        }
    }
}
